<template>
	<div>
		<v-toolbar color="indigo darken-2" dark class="mt-5">			        
	    	<v-icon>edit</v-icon>
	        <v-toolbar-title>Occupants and PIs</v-toolbar-title>
	        <v-spacer></v-spacer>
	        <v-btn icon @click="showPeople = !showPeople">
	          <v-icon>{{showPeople ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
	        </v-btn>
	    </v-toolbar>
	    <v-card flat v-if="showPeople" column class="pl-3 pr-4 body-1">
			<v-card-text class="pt-4 body-2">
			</v-card-text>
			<v-card-actions>
				<v-layout column>
					<EmployeeAutocomplete v-on:return-employee="setEmployee" 
						label="Add Employee by Name, Empl Num, or NetID"
						:soloinverted="true" 
						:key="reset"/>
					<v-card-text v-if="employees.length>0" class="pt-4 body-2">
						These employees will be ADDED to selected rooms.<br>
	    				{{employees.map((employee) => { return employee.name })}}
	    			</v-card-text>


					<v-layout v-if="employees.length > 0" row justify-space-between class="mt-3 mb-5">
						<v-dialog width="500" v-model="confirmDialog3">
							<template v-slot:activator="{ on }">
				            <v-btn dark class="" v-on="on" color="#a70000">
				            	{{employees.length > 1 ? 'Add Occupants' : 'Add Occupant'}}
				            </v-btn>
				        	</template>
				        	<v-card class="pl-2 pt-1 pr-2">
						        <v-card-title class="headline">Confirm ADD OCCUPANTS</v-card-title>
						        <v-divider></v-divider>
						        <v-card-text class="pt-4 body-2">
						        	Add employees to Selected Rooms?</v-card-text>
						        <v-card-actions>
						          	<v-spacer></v-spacer>
						          	<v-btn color="green darken-1" flat @click.native="confirmDialog3=false">No</v-btn>
						          	<v-btn color="green darken-1" flat 
						          		@click.native="addOccupant">Yes
						      	 	 </v-btn>
						        </v-card-actions>
					      	</v-card>
				    	</v-dialog>

				    	<v-dialog width="500" v-model="confirmDialog4">
							<template v-slot:activator="{ on }">
				            <v-btn dark class="" v-on="on" color="#a70000">
				            	{{employees.length > 1 ? 'Add PIs' : 'Add PI'}} 
				            </v-btn>
				        	</template>
				        	<v-card class="pl-2 pt-1 pr-2">
						        <v-card-title class="headline">Confirm ADD PIs</v-card-title>
						        <v-divider></v-divider>
						        <v-card-text class="pt-4 body-2">
						        	Add employees to Selected Rooms?</v-card-text>
						        <v-card-actions>
						          	<v-spacer></v-spacer>
						          	<v-btn color="green darken-1" flat @click.native="confirmDialog4=false">No</v-btn>
						          	<v-btn color="green darken-1" flat 
						          		@click.native="addPI">Yes
						      	 	 </v-btn>					      	 	
						        </v-card-actions>
					      	</v-card>
				    	</v-dialog>
			    	   	<v-btn color="green darken-1" flat @click.native="clearEmployees">Clear</v-btn>
			    	</v-layout>

					<v-dialog width="500" v-model="confirmDialog1">
						<template v-slot:activator="{ on }">
			            <v-btn dark class="mt-3" v-on="on" color="#a70000">
			            	Clear Occupants in Selected Rooms
			            </v-btn>
			        	</template>
			        	<v-card class="pl-2 pt-1 pr-2">
					        <v-card-title class="headline">Confirm</v-card-title>
					        <v-divider></v-divider>
					        <v-card-text class="pt-4 body-2">
					        	Clear Occupants in Selected Rooms?</v-card-text>
					        <v-card-actions>
					          	<v-spacer></v-spacer>
					          	<v-btn color="green darken-1" flat @click.native="confirmDialog1=false">No</v-btn>
					          	<v-btn color="green darken-1" flat 
					          		@click.native="clearOccupants">Yes
					      	 	 </v-btn>
					        </v-card-actions>
				      	</v-card>
			    	</v-dialog>

				    <v-dialog width="500" v-model="confirmDialog2">
						<template v-slot:activator="{ on }">
			            <v-btn dark class="mt-3" v-on="on" color="#a70000">
			            	Clear PIs in Selected Rooms
			            </v-btn>
			        	</template>
			        	<v-card class="pl-2 pt-1 pr-2">
					        <v-card-title class="headline">Confirm</v-card-title>
					        <v-divider></v-divider>
					        <v-card-text class="pt-4 body-2">
					        	Clear PIs in Selected Rooms?</v-card-text>
					        <v-card-actions>
					          	<v-spacer></v-spacer>
					          	<v-btn color="green darken-1" flat @click.native="confirmDialog2=false">No</v-btn>
					          	<v-btn color="green darken-1" flat 
					          		@click.native="clearPIs">Yes
					      	 	 </v-btn>
					        </v-card-actions>
				      	</v-card>
			    	</v-dialog>
		    	</v-layout>
		    </v-card-actions>
		</v-card>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete'

export default {
data () {
	return {
		showPeople: false,
		confirmDialog1: false,
		confirmDialog2: false,
		confirmDialog3: false,
		confirmDialog4: false,
		employee: null,
		reset: 1,
		employees: [],
	}
},

components: { EmployeeAutocomplete },

props: [ 'roomKeyArray', ],

computed: {
	...mapState({   	buildings: state => state.space.buildings,
				})
},

methods : {
	...mapMutations([ 	'setSnackText',
					]),
	...mapActions  ([ 	'bulkDeletePIs', 'bulkDeleteOccupants', 'bulkAddOccupant', 'bulkAddPI'
					]),

	clearOccupants : function () {
		this.confirmDialog1 = false
		this.bulkDeleteOccupants(this.roomKeyArray).then((response) => {
			this.setSnackText(response)
			//this.$emit("refresh") // Removed because it clears current selection
		})
	},

	clearPIs : function () {
		this.confirmDialog2 = false
		this.bulkDeletePIs(this.roomKeyArray).then((response) => {
			this.setSnackText(response)
			//this.$emit("refresh") // Removed because it clears current selection
		})
	},

	addOccupant : function () {
	
		let payload = {'roomKeyArray': this.roomKeyArray, 'empl_id_array': this.employees.map((employee) => { return employee.employeeID }) }
		this.bulkAddOccupant(payload).then((response) => {
			this.setSnackText(response)				
			this.confirmDialog3 = false	
			this.reset=this.reset + 1
			this.employees=[]
			//this.$emit("refresh") // Removed because it clears current selection
		})
	},

	addPI : function () {		
		let payload = {'roomKeyArray': this.roomKeyArray, 'empl_id_array': this.employees.map((employee) => { return employee.employeeID }) }
		this.bulkAddPI(payload).then((response) => {
			this.setSnackText(response)	
			this.reset=this.reset + 1	
			this.confirmDialog4 = false	
			this.employees=[]
			//this.$emit("refresh") // Removed because it clears current selection
		})		
	},

	setEmployee(value) {
		this.employee = value
		this.employees.push(value)
		this.reset=this.reset + 1
	},

	clearEmployees(value) {
		this.employees = []
	},
},
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/BulkRoomEditOccupantPI.vue